export default __webpack_public_path__ + "static/media/Kategori Produk-SERVING COLLECTION-2.046a0cd1.jpg";